import type { ProviderState } from './provider-state.enum';
import type { PagedRequestDto } from '../pagination/models';

export interface ContactDto {
  id: number;
  email?: string;
  providerId?: number;
}

export interface ContactInputDto {
  id: number;
  email: string;
  providerId: number;
  actionId?: number;
}

export interface ProviderDto {
  id: number;
  name: string;
  vatNumber: string;
  state?: ProviderState;
  contacts: ContactDto[];
  code: string;
}

export interface ProviderInputDto {
  id: number;
  name: string;
  vatNumber: string;
  state?: ProviderState;
  contacts: ContactInputDto[];
  code: string;
}

export interface ProviderPagedRequestDto extends PagedRequestDto {
  name?: string;
  vatNumber?: string;
  state?: ProviderState;
  code?: string;
}
